import gql from 'graphql-tag'

export const fetchTransportTypeMutation = gql(`
mutation ($cart_id: String!, $transporttype: String!, $currency: String!, $sappaymentmethod: String, $sappaymentcode: String, $runnertype: String) {
  setTransportType(
      cart_id: $cart_id
      transporttype: $transporttype
      currency: $currency
      sappaymentmethod: $sappaymentmethod
      sappaymentcode: $sappaymentcode
      runnertype: $runnertype
  ) {
    message
  }
}
`)
